import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { UsersIcon, DollarSignIcon, PlusIcon, BoxIcon, GavelIcon, SearchIcon, ShieldIcon, TrendingUpIcon, ArrowRightIcon, PercentIcon, UserPlusIcon, CreditCardIcon, BarChart2Icon, ClockIcon, CheckCircleIcon, XCircleIcon, AlertTriangleIcon, LockIcon, UnlockIcon, ChevronRightIcon, LayoutGridIcon, RefreshCwIcon, PackageIcon, CalendarIcon, InfoIcon } from 'lucide-react';
import { Progress } from '@/components/ui/progress';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import RechartsLineChart from '../components/charts/RechartsLineChart';
import RechartsBarChart from '../components/charts/RechartsBarChart';
const SyndicateHub: React.FC = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('active');
  const activeSyndicates = [{
    id: 1,
    name: 'Premium iPhone Collection',
    description: 'Bulk purchase of iPhone 13 Pro and Pro Max models',
    target: 100000,
    raised: 85000,
    members: 12,
    deadline: '2023-07-25',
    status: 'Active',
    type: 'Buying'
  }, {
    id: 2,
    name: 'Samsung S22 Ultra Bundle',
    description: 'Wholesale S22 Ultra devices, all grades',
    target: 75000,
    raised: 45000,
    members: 8,
    deadline: '2023-07-28',
    status: 'Active',
    type: 'Buying'
  }, {
    id: 3,
    name: 'Mixed Apple Inventory',
    description: 'Various iPhone models and conditions',
    target: 50000,
    raised: 42500,
    members: 6,
    deadline: '2023-07-30',
    status: 'Active',
    type: 'Selling'
  }];
  const syndicateStats = {
    activeSyndicates: 8,
    totalMembers: 45,
    totalValue: '$342,500',
    avgReturn: '15.8%'
  };
  return <div className="space-y-6" data-id="element-3316">
      <div className="flex items-center justify-between" data-id="element-3317">
        <div data-id="element-3318">
          <h1 className="text-2xl font-bold" data-id="element-3319">Syndicate Hub</h1>
          <p className="text-sm text-muted-foreground" data-id="element-3320">
            Pool resources and share opportunities with other traders
          </p>
        </div>
        <div className="flex space-x-2" data-id="element-3321">
          <Button variant="outline" data-id="element-3322">
            <UserPlusIcon className="mr-2 h-4 w-4" data-id="element-3323" />
            Join Syndicate
          </Button>
          <Button onClick={() => navigate('/syndicate-creation')} data-id="element-3324">
            <PlusIcon className="mr-2 h-4 w-4" data-id="element-3325" />
            Create Syndicate
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-3326">
        <Card data-id="element-3327">
          <CardContent className="p-4" data-id="element-3328">
            <div className="flex items-center justify-between" data-id="element-3329">
              <div data-id="element-3330">
                <p className="text-sm text-muted-foreground" data-id="element-3331">
                  Active Syndicates
                </p>
                <p className="text-2xl font-bold" data-id="element-3332">
                  {syndicateStats.activeSyndicates}
                </p>
              </div>
              <UsersIcon className="h-8 w-8 text-muted-foreground/30" data-id="element-3333" />
            </div>
          </CardContent>
        </Card>
        <Card data-id="element-3334">
          <CardContent className="p-4" data-id="element-3335">
            <div className="flex items-center justify-between" data-id="element-3336">
              <div data-id="element-3337">
                <p className="text-sm text-muted-foreground" data-id="element-3338">Total Members</p>
                <p className="text-2xl font-bold" data-id="element-3339">
                  {syndicateStats.totalMembers}
                </p>
              </div>
              <UserPlusIcon className="h-8 w-8 text-muted-foreground/30" data-id="element-3340" />
            </div>
          </CardContent>
        </Card>
        <Card data-id="element-3341">
          <CardContent className="p-4" data-id="element-3342">
            <div className="flex items-center justify-between" data-id="element-3343">
              <div data-id="element-3344">
                <p className="text-sm text-muted-foreground" data-id="element-3345">Total Value</p>
                <p className="text-2xl font-bold" data-id="element-3346">
                  {syndicateStats.totalValue}
                </p>
              </div>
              <DollarSignIcon className="h-8 w-8 text-muted-foreground/30" data-id="element-3347" />
            </div>
          </CardContent>
        </Card>
        <Card data-id="element-3348">
          <CardContent className="p-4" data-id="element-3349">
            <div className="flex items-center justify-between" data-id="element-3350">
              <div data-id="element-3351">
                <p className="text-sm text-muted-foreground" data-id="element-3352">Avg. Return</p>
                <p className="text-2xl font-bold" data-id="element-3353">{syndicateStats.avgReturn}</p>
              </div>
              <TrendingUpIcon className="h-8 w-8 text-muted-foreground/30" data-id="element-3354" />
            </div>
          </CardContent>
        </Card>
      </div>
      <Card data-id="element-3355">
        <CardHeader className="pb-2" data-id="element-3356">
          <div className="flex items-center justify-between" data-id="element-3357">
            <CardTitle data-id="element-3358">Syndicate Opportunities</CardTitle>
            <div className="relative" data-id="element-3359">
              <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" data-id="element-3360" />
              <input type="text" placeholder="Search syndicates..." className="pl-10 pr-4 py-2 rounded-md border bg-background text-sm w-64" data-id="element-3361" />
            </div>
          </div>
          <CardDescription data-id="element-3362">Browse and join active syndicates</CardDescription>
        </CardHeader>
        <CardContent data-id="element-3363">
          <Tabs defaultValue="active" value={activeTab} onValueChange={setActiveTab} data-id="element-3364">
            <TabsList className="mb-4" data-id="element-3365">
              <TabsTrigger value="active" data-id="element-3366">Active</TabsTrigger>
              <TabsTrigger value="my-syndicates" data-id="element-3367">My Syndicates</TabsTrigger>
              <TabsTrigger value="completed" data-id="element-3368">Completed</TabsTrigger>
            </TabsList>
            <TabsContent value="active" className="space-y-4" data-id="element-3369">
              {activeSyndicates.map(syndicate => <Card key={syndicate.id} className="overflow-hidden" data-id="element-3370">
                  <div className="flex flex-col md:flex-row" data-id="element-3371">
                    <div className="p-4 md:w-2/3" data-id="element-3372">
                      <div className="flex items-start justify-between" data-id="element-3373">
                        <div data-id="element-3374">
                          <div className="flex items-center" data-id="element-3375">
                            <h3 className="font-medium" data-id="element-3376">{syndicate.name}</h3>
                            <Badge variant="success" className="ml-2" data-id="element-3377">
                              {syndicate.status}
                            </Badge>
                            <Badge variant="outline" className="ml-2" data-id="element-3378">
                              {syndicate.type}
                            </Badge>
                          </div>
                          <p className="text-sm text-muted-foreground mt-1" data-id="element-3379">
                            {syndicate.description}
                          </p>
                        </div>
                      </div>
                      <div className="mt-4" data-id="element-3380">
                        <div className="flex justify-between text-sm mb-1" data-id="element-3381">
                          <span data-id="element-3382">
                            Progress (
                            {Math.round(syndicate.raised / syndicate.target * 100)}
                            %)
                          </span>
                          <span data-id="element-3383">
                            ${syndicate.raised} of ${syndicate.target}
                          </span>
                        </div>
                        <Progress value={syndicate.raised / syndicate.target * 100} className="h-2" data-id="element-3384" />
                      </div>
                      <div className="mt-4 flex items-center space-x-4 text-sm" data-id="element-3385">
                        <div className="flex items-center" data-id="element-3386">
                          <UsersIcon className="h-4 w-4 mr-1 text-muted-foreground" data-id="element-3387" />
                          <span data-id="element-3388">{syndicate.members} members</span>
                        </div>
                        <div className="flex items-center" data-id="element-3389">
                          <ClockIcon className="h-4 w-4 mr-1 text-muted-foreground" data-id="element-3390" />
                          <span data-id="element-3391">Ends {syndicate.deadline}</span>
                        </div>
                      </div>
                    </div>
                    <div className="p-4 bg-muted/30 border-t md:border-t-0 md:border-l md:w-1/3" data-id="element-3392">
                      <div className="space-y-4" data-id="element-3393">
                        <div data-id="element-3394">
                          <p className="text-sm font-medium mb-1" data-id="element-3395">
                            Minimum Investment
                          </p>
                          <p className="text-2xl font-bold" data-id="element-3396">$5,000</p>
                        </div>
                        <div className="space-y-2" data-id="element-3397">
                          <Button className="w-full" data-id="element-3398">Join Syndicate</Button>
                          <Button variant="outline" className="w-full" onClick={() => navigate(`/syndicate-detail/${syndicate.id}`)} data-id="element-3399">
                            Learn More
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card>)}
            </TabsContent>
            <TabsContent value="my-syndicates" data-id="element-3400">
              <div className="flex flex-col items-center justify-center h-40 border rounded-md bg-muted/30" data-id="element-3401">
                <p className="text-muted-foreground mb-4" data-id="element-3402">
                  Your syndicates will be displayed here
                </p>
                <Button onClick={() => navigate('/syndicate-creation')} data-id="element-3403">
                  <PlusIcon className="mr-2 h-4 w-4" data-id="element-3404" />
                  Create Your First Syndicate
                </Button>
              </div>
            </TabsContent>
            <TabsContent value="completed" data-id="element-3405">
              <div className="flex flex-col items-center justify-center h-40 border rounded-md bg-muted/30" data-id="element-3406">
                <p className="text-muted-foreground" data-id="element-3407">
                  Completed syndicates will be displayed here
                </p>
              </div>
            </TabsContent>
          </Tabs>
        </CardContent>
        <CardFooter className="border-t" data-id="element-3408">
          <Button variant="outline" size="sm" className="ml-auto" onClick={() => navigate('/syndicate-creation')} data-id="element-3409">
            <PlusIcon className="mr-2 h-4 w-4" data-id="element-3410" />
            Create New Syndicate
          </Button>
        </CardFooter>
      </Card>
    </div>;
};
export default SyndicateHub;